import { OnboardingProcessStep } from "../dtos";

export type ProcessStepFieldKey = "price";

export const getMissingProcessStepFields = (
  processStep: Pick<OnboardingProcessStep, "price">,
): ProcessStepFieldKey[] => {
  const missingFields: ProcessStepFieldKey[] = [];

  if (processStep.price === null) {
    missingFields.push("price");
  }

  return missingFields;
};
